// Native Base Utility Props 헬퍼

// =================================================================================================
// 가져오기
// =================================================================================================
// 고정 영역

// 동적 영역

// =================================================================================================
// 상수
// =================================================================================================
// NativeBase Utility Props [Style props are a way to alter the style of a component by simply passing props to it. It helps to save time by providing helpful shorthand ways to style components.]
const nativeBaseUtilityProps = {
  // Style Props [The following table shows a list of every style prop and the properties within each group.]
  //  Margin and padding
  margin: undefined, // margin [m] [하단 적용됨] [space]
  marginTop: undefined, // margin-top [mt] [space]
  marginRight: undefined, // margin-right [mr] [space]
  marginBottom: undefined, // margin-bottom [mb] [space]
  marginLeft: undefined, // margin-left [ml] [space]
  mx: undefined, // margin-left and margin-right [space]
  my: undefined, // margin-top and margin-bottom [space]
  padding: undefined, // padding [p] [space]
  paddingTop: undefined, // padding-top [pt] [space]
  paddingRight: undefined, // padding-right [pr] [space]
  paddingBottom: undefined, // padding-bottom [pb] [space]
  paddingLeft: undefined, //  padding-left [pl] [space]
  px: undefined, // padding-left and padding-right [space]
  py: undefined, // padding-top and padding-bottom [space]

  //  Color and background color
  color: undefined, // color [colors]
  background: undefined, // background [bg] [colors]
  bgColor: undefined, // background-color [colors]
  opacity: undefined, // opacity

  //  Typography
  fontFamily: undefined, // font-family [fonts]
  fontSize: undefined, // font-size [fontSizes]
  fontWeight: undefined, // font-weight [fontWeights]
  lineHeight: undefined, // line-height [lineHeights]
  letterSpacing: undefined, // letter-spacing [letterSpacings]
  textAlign: undefined, // text-align
  fontStyle: undefined, // font-style
  textTransform: undefined, // text-transform
  textDecoration: undefined, // text-decoration

  //  Layout, width and height
  width: undefined, // width [w] [nPx, fit-content, ...] [sizes]
  height: undefined, // height [h] [sizes]
  minWidth: undefined, // min-width [minW] [sizes]
  maxWidth: undefined, // max-width [minW] [sizes]
  minHeight: undefined, // min-height [minH] [sizes]
  maxHeight: undefined, // max-height [maxH] [sizes]
  display: undefined, // display [d]
  boxSize: undefined, // width, height [sizes]
  verticalAlign: undefined, // vertical-align
  overflow: undefined, // overflow
  overflowX: undefined, // overflowX
  overflowY: undefined, // overflowY

  //  Flexbox
  alignItems: undefined, // align-items [*align] 항목 가로 정렬 [css 기본 정의에서는 비 기준축 기준 항목 정렬]
  alignContent: undefined, // align-content
  justifyItems: undefined, // justify-items
  justifyContent: undefined, // justify-content [*justify] 항목 기준축(vertical: 세로, horizontal: 가로) 정렬
  flexWrap: undefined, // flex-wrap [*wrap]
  flexDirection: undefined, // flex-direction [flexDir, *direction]
  flex: undefined, // flex
  flexGrow: undefined, // flex-grow
  flexShrink: undefined, // flex-shrink
  flexBasis: undefined, // flex-basis
  justifySelf: undefined, // justify-self
  alignSelf: undefined, // align-self
  order: undefined, // order

  //  Borders
  borderWidth: undefined, // border-width
  borderStyle: undefined, // border-style
  borderColor: undefined, // border-color
  borderTop: undefined, // border-top
  borderTopWidth: undefined, // border-top-width
  borderTopStyle: undefined, // border-top-style
  borderTopColor: undefined, // border-top-color
  borderRight: undefined, // border-right
  borderRightWidth: undefined, // border-right-width
  borderRightStyle: undefined, // border-right-style
  borderRightColor: undefined, // border-right-color
  borderBottom: undefined, // border-bottom
  borderBottomWidth: undefined, // border-bottom-width
  borderBottomStyle: undefined, // border-bottom-style
  borderBottomColor: undefined, // border-bottom-color
  borderLeft: undefined, // border-left
  borderLeftWidth: undefined, // border-left-width
  borderLeftStyle: undefined, // border-left-style
  borderLeftColor: undefined, // border-left-color

  //  Borders Radius
  borderRadius: undefined, // borderRadius [rounded]
  borderTopLeftRadius: undefined, // border-top-left-radius [roundedTopLeft]
  borderTopRightRadius: undefined, // border-top-right-radius [roundedTopRight]
  borderBottomRightRadius: undefined, // border-bottom-right-radius [roundedBottomRight]
  borderBottomLeftRadius: undefined, // border-bottom-left-radius [roundedBottomLeft]
  borderTopRadius: undefined, // border-top-left-radius [roundedTop]
  borderRightRadius: undefined, // border-top-right-radius [roundedLeft]
  borderBottomRadius: undefined, // border-bottom-left-radius [roundedBottom]
  borderLeftRadius: undefined, // border-top-left-radius [roundedLeft]

  //  Position
  position: undefined, // position
  zIndex: undefined, // z-index [zIndices]
  top: undefined, // top [space]
  right: undefined, // right [space]
  bottom: undefined, // bottom [space]
  left: undefined, // left [space]

  //  Shadow
  shadow: undefined, // box-shadow

  // Underscore Props
  //  Internal Props [Provides a way to pass props to child components inside Composite components]
  _stack: undefined, // Passed props will be provided to  Stack    child.
  _text: undefined, // Passed props will be provided to   Text    child.

  //  Interaction Props [Provides a way to pass props on certain interaction]
  _disabled: undefined, // Passed props will be applied on disabled state.
  _focus: undefined, // Passed props will be applied on focused state.
  _hover: undefined, // Passed props will be applied on hovered state.
  _invalid: undefined, // Passed props will be applied on invalid state.
  _pressed: undefined, // 눌린 상태에서 적용될 속성들

  //  Platform Props [Provides a way to pass props based on Platform (android, ios or web).]
  _android: undefined, // 안드로이드에서 적용될 속성들
  _ios: undefined, // Passed props will be applied on ios.
  _web: undefined, // Passed props will be applied on web.

  // 그 외
  size: undefined, // 크기 (단위: 밀도독립화소=DIP=DP=모든장치에서 동일 크기로 보임) ResponsiveValue<number | "px" | "0" | "full" | "sm" | "6" | "2xs" | "8" | "xs" | "12" | "md" | "16" | "xl" | "24" | "32" | "2" | "0.5" | "4" | "3" | "lg" | "1" | "2xl" | "10" | "20" | "64" | "container" | ... 28 more ... | (string & {})>
};

// =================================================================================================
// 내보내기
// =================================================================================================
export default nativeBaseUtilityProps;
